:host {
  display: block;
}

:host {
  display: block;
  position: relative;
  width: 100%;
  font-family: var(--sc-input-font-family);
  font-weight: var(--sc-input-font-weight);
  line-height: var(--sc-line-height-normal);
  letter-spacing: var(--sc-input-letter-spacing);
}
::slotted(*) {
  /* font-size: var(--sc-font-size-medium);
  color: var(--sc-input-color);
  line-height: 1.75; */
}

::slotted([class~="lead"]) {
  color: var(--sc-input-color);
  font-size: var(--sc-input-spacing-small);
  line-height: 1.6;
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}

::slotted(strong) {
  font-weight: var(--sc-font-weight-bold);
}

::slotted(ol) {
  padding:0;
  margin-top: var(--sc-input-spacing-small);
  margin-bottom: var(--sc-input-spacing-small);
}

::slotted(ol > li) {
  position: relative;
}

::slotted(ul > li) {
  position: relative;
}

::slotted(hr) {
  border-color: var(--sc-color-gray-400);
  border-top-width: 1px;
  margin-top: 3em;
  margin-bottom: 3em;
}

::slotted(blockquote) {
  font-weight: var(--sc-font-weight-medium);
  font-style: italic;
  color: var(--sc-color-gray-800);
  border-left-width: 0.25rem;
  border-left-color: var(--sc-color-gray-400);
  quotes: "\201C""\201D""\2018""\2019";
  margin-top: 1.6em;
  margin-bottom: 1.6em;
  padding-left: 1em;
}

::slotted(blockquote p:first-of-type::before) {
  content: open-quote;
}

::slotted(blockquote p:last-of-type::after) {
  content: close-quote;
}

::slotted(h1) {
  font-weight: 800;
  font-size: 2.25em;
  margin-top: 0;
  margin-bottom: 0.8888889em;
  line-height: 1.1111111;
}

::slotted(h2) {
  font-weight: 700;
  font-size: 1.5em;
  margin-top: 2em;
  margin-bottom: 1em;
  line-height: 1.3333333;
}

::slotted(h3) {
  font-weight: 600;
  font-size: var(--sc-input-spacing-small);
  margin-top: 1.6em;
  margin-bottom: 0.6em;
  line-height: 1.6;
}

::slotted(h4) {
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.5;
}

::slotted(figure figcaption) {
  color: var(--sc-color-gray-600);
  font-size: 0.875em;
  line-height: 1.4285714;
  margin-top: 0.8571429em;
}

::slotted(code) {
  color: var(--sc-color-gray-900);
  font-weight: 600;
  font-size: 0.875em;
}

::slotted(code::before) {
  content: "`";
}

::slotted(code::after) {
  content: "`";
}

::slotted(pre) {
  color: var(--sc-color-gray-300);
  background-color: var(--sc-color-gray-800);
  overflow-x: auto;
  font-size: 0.875em;
  line-height: 1.7142857;
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
  border-radius: 0.375rem;
  padding-top: 0.8571429em;
  padding-right: 1.1428571em;
  padding-bottom: 0.8571429em;
  padding-left: 1.1428571em;
}

::slotted(pre code) {
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-weight: 400;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}

::slotted(pre code::before) {
  content: "";
}

::slotted(pre code::after) {
  content: "";
}

::slotted(table) {
  width: 100%;
  table-layout: auto;
  text-align: left;
  margin-top: 2em;
  margin-bottom: 2em;
  font-size: 0.875em;
  line-height: 1.7142857;
}

::slotted(thead) {
  color: #1a202c;
  font-weight: 600;
  border-bottom-width: 1px;
  border-bottom-color: var(--sc-color-gray-400);
}

::slotted(thead th) {
  vertical-align: bottom;
  padding-right: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-left: 0.5714286em;
}

::slotted(tbody tr) {
  border-bottom-width: 1px;
  border-bottom-color: var(--sc-color-gray-400);
}

::slotted(tbody tr:last-child) {
  border-bottom-width: 0;
}

::slotted(tbody td) {
  vertical-align: top;
  padding-top: 0.5714286em;
  padding-right: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-left: 0.5714286em;
}

::slotted(p),
::slotted(img),
::slotted(video),
::slotted(figure) {
  padding: 0 !important;
  margin-top: var(--sc-input-spacing-small) !important;
  margin-bottom: var(--sc-input-spacing-small) !important;
}

::slotted(figure > *) {
  margin-top: 0;
  margin-bottom: 0;
}

::slotted(h2 code) {
  font-size: 0.875em;
}

::slotted(h3 code) {
  font-size: 0.9em;
}

::slotted(ul) {
  margin-top: var(--sc-input-spacing-small);
  margin-bottom: var(--sc-input-spacing-small);
}

::slotted(li) {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

::slotted(ul > li p) {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}

::slotted(ul > li > *:first-child) {
  margin-top: var(--sc-input-spacing-small);
}

::slotted(ul > li > *:last-child) {
  margin-bottom: var(--sc-input-spacing-small);
}

::slotted( ol > li > *:first-child) {
  margin-top: var(--sc-input-spacing-small);
}

::slotted( ol > li > *:last-child) {
  margin-bottom: var(--sc-input-spacing-small);
}

::slotted(ul ul),
::slotted(ul ol),
::slotted(ol ul),
::slotted(ol ol) {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}

::slotted(hr + *) {
  margin-top: 0;
}

::slotted(h2 + *) {
  margin-top: 0;
}

::slotted(h3 + *) {
  margin-top: 0;
}

::slotted(h4 + *) {
  margin-top: 0;
}

::slotted(thead th:first-child) {
  padding-left: 0;
}

::slotted(thead th:last-child) {
  padding-right: 0;
}

::slotted(tbody td:first-child) {
  padding-left: 0;
}

::slotted(tbody td:last-child) {
  padding-right: 0;
}

::slotted(:first-child) {
  margin-top: 0;
}

::slotted(:last-child) {
  margin-bottom: 0;
}
